import ReplyOptions from './ReplyOptions';

export default ReplyOptions;


// WEBPACK FOOTER //
// /src/components/mailThread/mail/replyOptions/index.js